// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import Store from './js/store';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import ModalComponent from './components/dashboard/components/Modal.vue';
import BreadcrumbComponent from './components/dashboard/components/Breadcrumb';
// import AceCodeEditor from './components/dashboard/components/AceCodeEditor';
import VueTour from 'vue-tour';
import vSelect from 'vue-select';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import Rotate from './components/editor/resources/Rotate';
import SyncDrag from './components/editor/resources/SyncDrag';
import DeleteConfirmationModal from './components/general/DeleteConfirmationModal.vue'
import './js/directives/toggle';
import VueRecaptchaCheetah from 'vue-recaptcha/dist/vue-recaptcha.min';
import _ from 'lodash';
import money from 'v-money';

// import vueHeadful from 'vue-headful';

// Vue.component('vue-headful', vueHeadful);
// progressbar
import 'vue-progress-path/dist/vue-progress-path.css'
import VueProgress from 'vue-progress-path'
import VueProgressBar from 'vue-progressbar'
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
// import 'ruler.js/dist/ruler.min.css';
// import ruler from 'ruler.js/dist/ruler.min';
import 'animate.css/animate.min.css';
import 'jquery-ruler/jquery.ui.ruler.css';
import 'jquery-ruler/jquery-ruler';
import 'vue-datetime/dist/vue-datetime.css';
import 'vue-snotify/styles/simple.css';
import 'vue-tour/dist/vue-tour.css';
import './assets/icons/font/ct-icons.css';
import '@mdi/font/css/materialdesignicons.css'
import 'atvimg/atvImg.css';
import 'atvimg/atvImg';

import Datetime from 'vue-datetime';
import VModal from 'vue-js-modal';
import Snotify from 'vue-snotify';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {Sketch} from 'vue-color';

import Loading from './js/base/Loading';
import Listener from './js/base/Listener';
import Queue from './js/base/Queue';
import Translate from './js/base/Translate';

import {
  faQuestion,
  faThumbsUp,
  faDesktop,
  faTabletAlt,
  faMobileAlt,
  faArrowUp,
  faArrowDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faTimes,
  faTimesCircle,
  faEye,
  faEyeSlash,
  faChevronRight,
  faChevronLeft,
  faPlus,
  faSearch,
  faHome,
  faEdit,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faCogs,
  faLink,
  faPen,
  faArrowsAltH,
  faCoffee,
  faChevronDown,
  faChevronUp,
  faSort,
  faSortDown,
  faAngleRight,
  faAngleLeft,
  faLayerGroup,
  faBars,
  faThumbtack,
  faQuestionCircle,
  faGripHorizontal,
  faGripVertical,
  faTh,
  faThLarge,
  faThList,
  faSortAlphaUp,
  faSortAlphaDown,
  faArrowsAlt,
  faFolder,
  faFolderOpen,
  faPhotoVideo,
  faVideo,
  faCheck,
  faEllipsisH,
  faEllipsisV,
  faShareAlt,
  faClone as faCloneFas,
  faTrash as faTrashFas,
  faTrashAlt as faTrashFasAlt,
  faUpload,
  faSquare,
  faTv,
  faEnvelopeOpenText,
  faClock as faClockFas,
  faGripLines,
  faIdCard,
  faImages,
  faImage,
  faCode,
  faWindowMinimize,
  faBorderAll,
  faRulerHorizontal,
  faCopy,
  faExternalLinkSquareAlt,
  faExternalLinkAlt,
  faPlay,
  faFont,
  faSync,
  faRedo,
  faUndo,
  faTint,
  faFilter,
  faExclamationTriangle,
  faExclamationCircle,
  faCaretUp,
  faCaretDown,
  faPlusCircle
} from '@fortawesome/free-solid-svg-icons'; // fas
import {
  faTrashAlt,
  faClock,
  faSave,
  faClone,
  faCalendar,
  faWindowMaximize,
  faEdit as faEditOutline
} from '@fortawesome/free-regular-svg-icons';// far

import { languages } from '../static/translation/index.js';

import BoxComponent from './components/editor/apps/Box/Box';
import BoxHoverComponent from './components/editor/apps/BoxHover/BoxHover';
import ImageComponent from './components/editor/apps/Image/Image.vue';
import TextComponent from './components/editor/apps/Text/Text.vue';
import ButtonComponent from './components/editor/apps/Button/Button.vue';
import MailingBossFormComponent from './components/editor/apps/Forms/MailingBossForm/MailingBossForm';
import LaunchAppComponent from './components/editor/apps/Forms/Launch/LaunchApp';
import GetResponseFormComponent from './components/editor/apps/Forms/GetResponseForm/GetResponseForm';
import SimpleFormComponent from './components/editor/apps/Forms/SimpleForm/SimpleForm';
import MultiStepFormComponent from './components/editor/apps/Forms/MultiStepForm/MultiStepForm';
import YoutubeVideoComponent from './components/editor/apps/YoutubeVideo/Youtube';
import IframeComponent from './components/editor/apps/Iframe/Iframe';
import MenuComponent from './components/editor/apps/Menu/Menu';
import VimeoVideoComponent from './components/editor/apps/Vimeo/Vimeo';
import PandaVideoComponent from './components/editor/apps/PandaVideo/PandaVideo';
import WebinarVideoComponent from './components/editor/apps/Webinar/Webinar';
import TimerComponent from './components/editor/apps/Timer/Timer';
import LineVComponent from './components/editor/apps/LineV/LineV';
import LineComponent from './components/editor/apps/Line/Line';
import WistiaVideoComponent from './components/editor/apps/WistiaVideo/Wistia';
import SliderGalleryComponent from './components/editor/apps/SliderGallery/SliderGallery';
import Image3DComponent from './components/editor/apps/Image3D/Image3D';
import CounterTextComponent from './components/editor/apps/CounterText/CounterText';
import CounterBarComponent from './components/editor/apps/CounterBar/CounterBar';
import ImageGalleryComponent from './components/editor/apps/ImageGallery/ImageGallery';
import SocialBarComponent from './components/editor/apps/SocialBar/SocialBar';
import InstagramFeedComponent from './components/editor/apps/InstagramFeed/InstagramFeed';
import AccordionComponent from './components/editor/apps/AccordionElement/Accordion/Accordion';
import AccordionGroupComponent from './components/editor/apps/AccordionElement/AccordionGroup/AccordionGroup';
import SliderGroupComponent from './components/editor/apps/SliderDropGallery/SliderGroup/SliderGroup';
import SliderPageComponent from './components/editor/apps/SliderDropGallery/SliderPage/SliderPage';
import PlaceMenuComponent from './components/editor/apps/BigMenu/PlaceMenu/PlaceMenu';
import GroupMenuComponent from './components/editor/apps/BigMenu/GroupMenu/GroupMenu';
import VidelloVideoComponent from './components/editor/apps/VidelloVideo/Vidello';
import VideoGalleryGroupComponent from './components/editor/apps/VideoGallery/Gallery/Gallery';
import VideoGalleryComponent from './components/editor/apps/VideoGallery/Video/Video';
import LottieFileComponent from './components/editor/apps/LottieFile/LottieFile.vue';
import FloatingButtonComponent from './components/editor/apps/FloatingButton/FloatingButton.vue';

// Booking
import BookingCalendarComponent from './components/editor/apps/Booking/Calendar/Calendar'

// Quiz
import QuizComponent from './components/editor/apps/Quiz/Quiz'

// super checkout
import CheckoutComponent from './components/editor/apps/Checkout/Checkout'

// blog
import BlogFeedNewsComponent from './components/editor/apps/Blog/Feed/FeedNews';
import BlogPostComponent from './components/editor/apps/Blog/Post/Post';
import BlogSearchComponent from './components/editor/apps/Blog/Search/Search';
import BlogCategoriesListComponent from './components/editor/apps/Blog/Categories/CategoriesList';
import BlogRssFeedComponent from './components/editor/apps/Blog/RSS/Rss';
import BlogAuthorCardComponent from './components/editor/apps/Blog/AuthorCard/Card';
import BlogFeaturedComponent from './components/editor/apps/Blog/Featured/Featured';
import BlogFeaturedGroupComponent from './components/editor/apps/Blog/FeaturedGroup/FeaturedGroup';
import BlogArticleListComponent from './components/editor/apps/Blog/Lists/Article/ArticleList';

import BlogNewsSliderComponent from './components/editor/apps/Blog/NewsSlider/NewsSlider';

import ButtonUserComponent from './components/editor/apps/Members/ButtonUser/ButtonUser';
import ContentNavUserComponent from './components/editor/apps/Members/ContentNavUser/ContentNavUser';


import VideoComponent from './components/editor/apps/Video/Video.vue';

//resources

import Collapse from "./components/editor/base/sidebar/Abstract/Collapse";
Vue.component('CcCollapse', Collapse);

import BoxColor from "./components/editor/resources/BoxColor";
Vue.component('CcBoxColor', BoxColor);

import Slider from "./components/editor/resource_components/Slider";
Vue.component('CcSliderComponent', Slider);

import CcImageComponent from "./components/editor/resource_components/Image"
Vue.component('CcImageComponent', CcImageComponent);

import CcBorderComponent from "./components/editor/resource_components/Border"
Vue.component('CcBorderComponent', CcBorderComponent);

import CcBorderRadiusComponent from "./components/editor/resource_components/BorderRadius"
Vue.component('CcBorderRadiusComponent', CcBorderRadiusComponent);

import CcShadow from "./components/editor/resource_components/Shadow"
Vue.component('CcShadow', CcShadow);

import CcParallax from "./components/editor/resource_components/Parallax"
Vue.component('CcParallax', CcParallax);

import CcAnimation from "./components/editor/resource_components/Animation"
Vue.component('CcAnimation', CcAnimation);

import CcTag from "./components/editor/resource_components/Tag"
Vue.component('CcTag', CcTag);

import CcZIndex from "./components/editor/resource_components/ZIndex"
Vue.component('CcZIndex', CcZIndex);

import CcSticky from "./components/editor/resource_components/Sticky"
Vue.component('CcSticky', CcSticky);

import CcPadding from "./components/editor/resource_components/Padding"
Vue.component('CcPadding', CcPadding);

import CcDivider from "./components/editor/resource_components/Divider"
Vue.component('CcDivider', CcDivider);

import CcVideoBackground from "./components/editor/resource_components/VideoBackground"
Vue.component('CcVideoBackground', CcVideoBackground);


import CcAnchor from "./components/editor/resource_components/Anchor"
Vue.component('CcAnchor', CcAnchor);

import CcArrowConfig from "./components/editor/resource_components/ArrowConfig"
Vue.component('CcArrowConfig', CcArrowConfig);


// import CcArrowConfig from "./components/editor/resource_components/ArrowConfig"
// Vue.component('CcArrowConfig', CcAnchor);


import ModalManager from "./components/editor/base/ModalManager";
Vue.component('CcModalManager', ModalManager);




library.add(
  faPlay,
  faQuestion,
  faThumbsUp,
  faDesktop,
  faMobileAlt,
  faTabletAlt,
  faArrowUp,
  faArrowDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faChevronRight,
  faChevronLeft,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTrashFasAlt,
  faTrashFas,
  faClone,
  faCloneFas,
  faEye,
  faEyeSlash,
  faPlus,
  faPlusCircle,
  faSearch,
  faHome,
  faEdit,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faClock,
  faCalendar,
  faCogs,
  faLink,
  faPen,
  faArrowsAltH,
  faCoffee,
  faChevronDown,
  faExclamationCircle,
  faChevronUp,
  faSort,
  faSortDown,
  faAngleRight,
  faAngleLeft,
  faLayerGroup,
  faBars,
  faSave,
  faQuestionCircle,
  faThumbtack,
  faGripHorizontal,
  faGripVertical,
  faTh,
  faThLarge,
  faThList,
  faSortAlphaUp,
  faSortAlphaDown,
  faArrowsAlt,
  faFolder,
  faFolderOpen,
  faPhotoVideo,
  faVideo,
  faCheck,
  faEditOutline,
  faEllipsisH,
  faEllipsisV,
  faShareAlt,
  faUpload,
  faSquare,
  faTv,
  faEnvelopeOpenText,
  faClockFas,
  faGripLines,
  faIdCard,
  faImages,
  faImage,
  faCode,
  faWindowMinimize,
  faAlignLeft,
  faBorderAll,
  faFont,
  faSync,
  faRedo,
  faUndo,
  faWindowMaximize,
  faTint,
  faRulerHorizontal,
  faCopy,
  faExternalLinkSquareAlt,
  faExternalLinkAlt,
  faFilter,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
  faPlusCircle
);

Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('sketch-picker', Sketch);
Vue.component('breadcrumb-component', BreadcrumbComponent);
// Vue.component('ace-code-editor', AceCodeEditor);
Vue.component('v-select', vSelect);
Vue.component('rotate', Rotate);
Vue.component('sync-drag', SyncDrag);
Vue.component('vue-recaptcha-cheetah', VueRecaptchaCheetah);
Vue.component('delete-confirmation-modal', DeleteConfirmationModal);

// blog apps
Vue.component('BlogFeedNewsComponent', BlogFeedNewsComponent);
Vue.component('BlogPostComponent', BlogPostComponent);
Vue.component('BlogSearchComponent', BlogSearchComponent);
// categorias/datas/tags e etc
Vue.component('BlogCategoriesListComponent', BlogCategoriesListComponent);

Vue.component('BoxComponent', BoxComponent);
Vue.component('BoxHoverComponent', BoxHoverComponent);
Vue.component('ImageComponent', ImageComponent);
Vue.component('TextComponent', TextComponent);
Vue.component('ButtonComponent', ButtonComponent);
Vue.component('MailingBossFormComponent', MailingBossFormComponent);
Vue.component('LaunchAppComponent', LaunchAppComponent);



Vue.component('GetResponseFormComponent', GetResponseFormComponent);
Vue.component('SimpleFormComponent', SimpleFormComponent);
Vue.component('MultiStepFormComponent', MultiStepFormComponent);
Vue.component('YoutubeVideoComponent', YoutubeVideoComponent);
Vue.component('IframeComponent', IframeComponent);
Vue.component('MenuComponent', MenuComponent);
Vue.component('VimeoVideoComponent', VimeoVideoComponent);
Vue.component('PandaVideoComponent', PandaVideoComponent);
Vue.component('WebinarVideoComponent', WebinarVideoComponent);
Vue.component('TimerComponent', TimerComponent);
Vue.component('LineVComponent', LineVComponent);
Vue.component('LineComponent', LineComponent);
Vue.component('WistiaVideoComponent', WistiaVideoComponent);
Vue.component('SliderGalleryComponent', SliderGalleryComponent);
Vue.component('Image3DComponent', Image3DComponent);
Vue.component('CounterTextComponent', CounterTextComponent);
Vue.component('CounterBarComponent', CounterBarComponent);
Vue.component('ImageGalleryComponent', ImageGalleryComponent);
Vue.component('SocialBarComponent', SocialBarComponent);
Vue.component('InstagramFeedComponent', InstagramFeedComponent);
Vue.component('AccordionGroupComponent', AccordionGroupComponent);
Vue.component('AccordionComponent', AccordionComponent);
Vue.component('SliderGroupComponent', SliderGroupComponent);
Vue.component('SliderPageComponent', SliderPageComponent);
Vue.component('PlaceMenuComponent', PlaceMenuComponent);
Vue.component('GroupMenuComponent', GroupMenuComponent);
Vue.component('VideoGalleryGroupComponent', VideoGalleryGroupComponent);
Vue.component('VideoGalleryComponent', VideoGalleryComponent);
Vue.component('VidelloVideoComponent', VidelloVideoComponent);
Vue.component('BookingCalendarComponent', BookingCalendarComponent)
Vue.component('QuizComponent', QuizComponent)

Vue.component('BlogRssComponent', BlogRssFeedComponent);
Vue.component('BlogAuthorCardComponent', BlogAuthorCardComponent);
Vue.component('BlogNewsSliderComponent', BlogNewsSliderComponent);

Vue.component('ButtonUserComponent', ButtonUserComponent);
Vue.component('ContentNavUserComponent', ContentNavUserComponent);

// super checkout
Vue.component('CheckoutComponent', CheckoutComponent)

//blog
Vue.component('BlogFeaturedComponent', BlogFeaturedComponent);
Vue.component('BlogFeaturedGroupComponent', BlogFeaturedGroupComponent);

Vue.component('BlogArticleListComponent', BlogArticleListComponent);


Vue.component('VideoComponent', VideoComponent);
Vue.component('LottieFileComponent', LottieFileComponent);
Vue.component('FloatingButtonComponent', FloatingButtonComponent);

Vue.component('toggle', {
  template: `<input type="checkbox" :checked="value" @input="input">`,
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  methods: {
    input(e) {
      this.$emit('input', e.target.checked);
    }
  }
});

Vue.use(VModal);
Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Snotify);
Vue.use(VueTour);
Vue.use(Vuelidate);
Vue.use(Datetime);
Vue.use(VueI18n);
Vue.use(Tooltip);
Vue.use(VueProgress);
Vue.use(_);
Vue.use(VueProgressBar, {
  color: '#0080FC',
  failedColor: 'red',
  thickness: '2px',
  transition: {speed: '0.5s', opacity: '0.5s', termination: 400}
});
Vue.use(LottieVuePlayer);
Vue.use(money, {
  decimal: '',
  thousands: '.',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: false
});

let defaultLocale = (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
const messages = Object.freeze(Object.assign(languages));

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en_US',
  silentTranslationWarn: true,
  messages
});

const removeEmptyValuesObj = (obg) => {
  Object.keys(obg).forEach(key => {
    if (obg[key] && typeof obg[key] === 'object') {
      removeEmptyValuesObj(obg[key]);
      if (Object.keys(obg[key]).length === 0) delete obg[key];
    } else if (obg[key] === null || obg[key].length === 0) delete obg[key];
  });
};

const isJson = (data) => {
  try {
    JSON.parse(data);
    return true;

  } catch (e) {
    return false;
  }
};

const getTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {
    return '';
  }
}

const getUrlWebsite = (website, user) => {
  try {
    if (typeof website.url !== null) {
      if (
        typeof website.dominio !== null &&
        website.dominio !== '' &&
        website.dominio !== null
      ) {
        return 'https://' + website.dominio;
      } else if (user.user_editor && user.user_editor.subdominio) {
        let subdominio = user.user_editor.subdominio.replace('_', '-');
        var dominio = typeof process.env.PREMIUN_DOMAIN !== 'undefined' ? process.env.PREMIUN_DOMAIN : '.site.builderallsite.com';

        if(user.is_free === '1'){
          dominio = typeof process.env.FREE_DOMAIN !== 'undefined' ? process.env.FREE_DOMAIN : '.free.builderallsite.com';
        }

        return ('https://' +
          subdominio +
          '-' +
          website.url.replace('_', '-') +
          dominio);
      } else return '';
    }
  } catch (e) {
    return '';
  }
}

const cutLongString = (string, max) => {
  try {
    return string.length > max ? string.substring(0, max - 3) + '...' : string;
  } catch (e) {
    return '';
  }
}

const cutString = (maxSize, string) => {
  try {
    return string.length > maxSize ? string.substring(0, maxSize) + '...' : string
  } catch (e) {
    return '';
  }
}

const debounce = (callback, wait) => {
  let timeout;
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
};

/**
 * compatibility: before fa implementation, 
 * the prefix was not saved with slug before (eg mdi-account)
 * now yes: eg mdi mdi-account / fa-regular fa-bell
 */
const addIconPrefix = name => {
  return (name.indexOf('mdi-') === 0 ? 'mdi' : '') + ' ' + name
}

const checkIsBundle = () => {
  const planSlug = localStorage.getItem('plan_slug') || '';
  return [
    'bundle-plan',
    'free-usd',
    'free-brl',
    'free-eur'
  ]
  .includes(planSlug)
}

// Vue.config.fallbackLang = 'en' doesn't seem to do anything. If I switch from en to ru I get the key instead of english.
Vue.prototype.$translate = new Translate();
Vue.prototype.$trans = Vue.prototype.$translate.get;
Vue.prototype.$categories = {};
Vue.prototype.$lang =
  window.navigator.userLanguage || window.navigator.language;
Vue.prototype.$languages = {};
Vue.prototype.$loading = new Loading();
Vue.prototype.$eventHub = new Listener();
Vue.prototype.$eventPointer = new Queue();
Vue.prototype.$removeEmptyValuesObj = removeEmptyValuesObj;
Vue.prototype.$isJson = isJson;
Vue.prototype.$getTimeZone = getTimeZone;
Vue.prototype.$getUrlWebsite = getUrlWebsite;
Vue.prototype.$cutLongString = cutLongString;

Vue.prototype.$debounce = debounce;
Vue.prototype.$cutString = cutString;
Vue.prototype.$addIconPrefix = addIconPrefix;

Vue.prototype.$isBundle = checkIsBundle

Vue.config.ignoredElements = [
    'builderall-footer',
    'builderall-help',
    'builderall-banner',
    'builderall-icon',
    'builderall-loader'
]

Vue.prototype.$globalStoreHelpers = new Vue({
  data: {
    isValidHex: (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex),
    hexToRGBA: (hex, alpha) => {

      function isValidHex(hex) {
        return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)
      }

      function getChunksFromString(st, chunkSize) {
        return st.match(new RegExp(`.{${chunkSize}}`, "g"))
      }

      function convertHexUnitTo256(hexStr) {
        return parseInt(hexStr.repeat(2 / hexStr.length), 16)
      }

      function getAlphafloat(a, alpha) {
        if (typeof a !== "undefined") {
          return a / 255
        }
        if (typeof alpha !== "undefined") {
          if (1 < alpha && alpha <= 100) {
            return alpha / 100
          }
          if (0 <= alpha && alpha <= 1) {
            return alpha
          }
        }
        return 1
      }

      if (!isValidHex(hex)) {
        throw new Error("Invalid HEX")
      }
      const chunkSize = Math.floor((hex.length - 1) / 3);
      const hexArr = getChunksFromString(hex.slice(1), chunkSize);
      const [r, g, b, a] = hexArr.map(convertHexUnitTo256);
      return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`
    }
  },
});

import { ModalPlugin } from 'bootstrap-vue'
const BV_CONFIG = {
  BModal: {
    centered: true,
    noFade: false,
    okVariant: 'success',
    okTitle: 'ct-save',
    cancelVariant: 'outline-secondary',
    cancelTitle: 'ct-cancel'
  }
}
Vue.use(ModalPlugin, BV_CONFIG);

/* eslint-disable no-new */
var vm = new Vue({
  i18n,
  el: '#app',
  store: new Vuex.Store(Store),
  router,
  components: {App, ModalComponent},
  template: '<App/>',
  created: function() {
    this.checkLogin();
  },
  watch: {
    $route: 'checkLogin'
  },
  methods: {
    checkLogin() {
      if (this.$route.name === 'Home' || this.$route.name === 'Dashboard') {
        $('#popup-overview-opened').show();
      } else {
        $('#popup-overview-opened').hide();
      }

      if (location.hostname.indexOf('website-builder.') > -1) {
        $('#popup-overview-opened').hide();
      }

      if(this.$route.name !== 'CreateWebsite') {
        document.getElementById('app').classList.remove('container-template-fixed')
      }

      var login = !!(
        localStorage.getItem('login') &&
        localStorage.getItem('login') === 'true'
      );

      if (this.$route.name === 'Redirector') return;
      if (this.$route.name === 'PublicLinkSave') return;
      if (this.$route.name === 'TemplatePreview') return;

      if (!login && this.$route.name === 'register') {
        this.$router.push('register');
        return;
      }

      if (!login) {
        this.$router.push({
          name: 'Login',
          params: this.$route.params
        });
      }
    }
  }
});

window.vm = vm;


window.addScript = function(src) {
  var s = document.createElement('script');
  s.setAttribute('src', src);
  document.body.appendChild(s);
};

window.mergeRecursive = function(obj1, obj2) {
  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor == Object) {
        obj1[p] = window.mergeRecursive(obj1[p], obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];
    }
  }

  return obj1;
};



// WEBPACK FOOTER //
// ./src/main.js